import React from 'react';
import linkUtils from 'js/linkUtils';

// [BB-1561] horrible hack to be able to refresh the page to redirect to solaris-fe and
const LinkToSolaris = (props) => {
  const { href, onClick, children } = props;
  return (
    <a
      {...props}
      onClick={e => {
        onClick(e);
        linkUtils.clickAndRefresh(e, href);
      }}
    >
      {children}
    </a>
  );
};

LinkToSolaris.defaultProps = {
  href: '',
  onClick: () => {},
};

export default LinkToSolaris;



// WEBPACK FOOTER //
// ./app/assets/jsx/components/community/linkToSolaris.jsx